"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseApp = void 0;
const tslib_1 = require("tslib");
const CustomClaimsMap_1 = require("../mappers/CustomClaimsMap");
const utils_1 = require("./utils");
const DatabaseRefs_1 = tslib_1.__importDefault(require("../../common/domain/structures/DatabaseRefs"));
const lodash_1 = require("lodash");
const UserRepo_1 = require("../../common/repos/UserRepo");
const OrgConfigMap_1 = require("../../common/mappers/OrgConfigMap");
const axios_1 = tslib_1.__importDefault(require("axios"));
const forgeApi_1 = require("../../modules/firebaseFn/httpRoutes/forgeApi");
const EHttpAuth_1 = require("../../common/domain/valueObjects/enums/EHttpAuth");
class FirebaseApp {
    constructor(app, config) {
        this.defaultLang = "en";
        this.currentLang = this.defaultLang;
        this.rootRefs = DatabaseRefs_1.default.rootRefs;
        this.isLoaded = false;
        this.isEmpty = true;
        this.app = app;
        this.db = app.database();
        this.st = app.storage();
        this.fn = app.functions();
        this.auth = app.auth();
        this.config = config;
        this.initFunctions();
    }
    /**
     * Conditionally displays ui component. This could be url, menu, widget ect.
     * Component is displayed based on combination of  orgConfig,global and user permissions.
     * Currently the global and orgConfig override user permissions. It is done that way only
     * because it required less refactoring at the moment.
     *TODO
     * This behaviour should be changed to "AND merge" style.
     * Permission will be valid only if it is set on all 3 levels (global,org, user).
     * Later we can extend these levels to units(groups) as well.
     *  For this change we need:
     *  1. add all components to global,
     *  2. add components to orgConfig for all existing orgs,
     *  3. add setup of default orgConfig to create org action
     *
     * @param componentKey
     * @param permissions
     */
    ui(componentKey, permissions) {
        var _a, _b, _c, _d;
        if (lodash_1.isObject(((_c = (_b = (_a = this.orgConfig) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.portalUiPermissions) !== null && _c !== void 0 ? _c : {})[componentKey])) {
            return this.orgUi(componentKey, permissions);
        }
        if (lodash_1.isObject(((_d = this.globalPortalUiPermissions) !== null && _d !== void 0 ? _d : {})[componentKey])) {
            return this.globalUi(componentKey, permissions);
        }
        if (this.isLoaded) {
            for (const p of permissions) {
                if (lodash_1.get(this.portalUiPermissions, [componentKey, p], false))
                    return true;
            }
        }
        return false;
    }
    globalUi(componentKey, permissions) {
        if (this.isLoaded && lodash_1.isObject(this.globalPortalUiPermissions)) {
            for (const p of permissions) {
                if (lodash_1.get(this.globalPortalUiPermissions, [componentKey, p], false))
                    return true;
            }
        }
        return false;
    }
    orgUi(componentKey, permissions) {
        var _a, _b, _c, _d;
        if (this.isLoaded && lodash_1.isObject((_b = (_a = this.orgConfig) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.portalUiPermissions)) {
            for (const p of permissions) {
                if (lodash_1.get((_d = (_c = this.orgConfig) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.portalUiPermissions, [componentKey, p], false))
                    return true;
            }
        }
        return false;
    }
    //TODO use ui after it is refactored
    isPathAllowed(path) {
        var _a, _b, _c, _d;
        if (this.isLoaded) {
            if (Array.isArray((_b = (_a = this.orgConfig) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.allowedPaths)) {
                return (_d = (_c = this.orgConfig) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.allowedPaths.includes(path);
            }
            return true;
        }
        return false;
    }
    initFunctions() {
        this.cf = {
            sendCloudMessage: this.fn.httpsCallable("sendCloudMessage"),
            setSupportRole: this.fn.httpsCallable("setSupportRole"),
            userByEmail: this.fn.httpsCallable("userByEmail"),
            addressToLocation: this.fn.httpsCallable("addressToLocation"),
            copyModelV2: this.fn.httpsCallable("copyModelV2"),
            createJiraIssue: this.fn.httpsCallable("createJiraIssue"),
            createUser: this.fn.httpsCallable("createUser"),
            deleteFile: this.fn.httpsCallable("deleteFile"),
            deleteUser: this.fn.httpsCallable("deleteUser"),
            sendEmailWithTemplateId: this.fn.httpsCallable("sendEmailWithTemplateId"),
            moveFromTemp: this.fn.httpsCallable("moveFromTemp"),
            searchAddress: this.fn.httpsCallable("searchAddress"),
            updateJiraIssue: this.fn.httpsCallable("updateJiraIssue"),
            userById: this.fn.httpsCallable("userById"),
            unitUpdate: this.fn.httpsCallable("unitUpdate"),
            projectDelete: this.fn.httpsCallable("projectDelete"),
            roleUpdate: this.fn.httpsCallable("roleUpdate"),
            userMigrate: this.fn.httpsCallable("userMigrate"),
            currentUserResetPassword: this.fn.httpsCallable("currentUserResetPassword"),
            generateSignInLink: this.fn.httpsCallable("generateSignInLink"),
            sendEmailSignInLink: this.fn.httpsCallable("sendEmailSignInLink"),
            onCallActionApi: this.fn.httpsCallable("onCallActionApi"),
            forgeApi: {
                token: (userId) => this.startHttpsCloudFunction(forgeApi_1.token(userId)),
                dataManagement: (userId, id) => this.startHttpsCloudFunction(forgeApi_1.dataManagement(userId, id)),
                code: (userId, code) => this.startHttpsCloudFunction(forgeApi_1.callback(userId, code)),
                url: (userId) => this.startHttpsCloudFunction(forgeApi_1.url(userId)),
                profile: (userId) => this.startHttpsCloudFunction(forgeApi_1.profile(userId)),
                getIssues: (userId, containerId, urn) => this.startHttpsCloudFunction(forgeApi_1.issuesGET(userId, containerId, urn)),
                createIssue: (userId, containerId, payload) => this.startHttpsCloudFunction(forgeApi_1.issuesPOST(userId, containerId), "POST", payload),
                updateIssue: (userId, containerId, issueId, payload) => this.startHttpsCloudFunction(forgeApi_1.issuePATCH(userId, containerId, issueId), "POST", payload),
                getIssueTypes: (userId, containerId) => this.startHttpsCloudFunction(forgeApi_1.issueTypesGET(userId, containerId)),
            },
        };
    }
    static async create(app, config) {
        return utils_1.rslv((async function () {
            const fbApp = new FirebaseApp(app, config);
            const claimsRes = await FirebaseApp.fetchClaims(app);
            if (claimsRes.isFail)
                throw new Error(`fetchClaims ${claimsRes.errMsg()}`);
            fbApp.claims = claimsRes.getValue();
            fbApp.userId = fbApp.claims.userId;
            fbApp.orgId = fbApp.claims.orgId;
            fbApp.accountId = fbApp.claims.accountId;
            fbApp.ouRefs = DatabaseRefs_1.default.builder.byOrgIdUserIdAll(fbApp.claims);
            const uiPortalRes = await utils_1.rslv(FirebaseApp.fetchPortalUiPermissions(fbApp));
            if (uiPortalRes.isFail)
                throw new Error(`fetchAppUiPermissions ${uiPortalRes.errMsg()}`);
            fbApp.portalUiPermissions = uiPortalRes.getValue();
            const uiGlobalPortalRes = await utils_1.rslv(FirebaseApp.fetchGlobalPortalUiPermissions(fbApp));
            if (uiGlobalPortalRes.isFail)
                throw new Error(`fetchAppUiPermissions ${uiGlobalPortalRes.errMsg()}`);
            fbApp.globalPortalUiPermissions = uiGlobalPortalRes.getValue();
            const repo = new UserRepo_1.UserRepo(fbApp);
            const userRes = await repo.fetchUser(fbApp.userId);
            if (userRes.isFail)
                throw new Error(`fetchUser ${userRes.errMsg()}`);
            fbApp.user = userRes.getValue();
            const uiAppRes = await utils_1.rslv(FirebaseApp.fetchAppUiPermissions(fbApp));
            if (uiAppRes.isFail)
                throw new Error(`fetchAppUiPermissions ${uiAppRes.errMsg()}`);
            fbApp.appUiPermissions = uiAppRes.getValue();
            fbApp.email =
                fbApp.auth.currentUser.email ||
                    (Array.isArray(fbApp.auth.currentUser.providerData) && fbApp.auth.currentUser.providerData[0].email);
            fbApp.displayName = fbApp.auth.currentUser.displayName
                ? fbApp.auth.currentUser.displayName.trim()
                : fbApp.email;
            fbApp.orgConfig = await FirebaseApp.fetchOrgConfig(fbApp);
            console.log("fbApp created", fbApp);
            fbApp.isLoaded = true;
            fbApp.isEmpty = false;
            return fbApp;
        })());
    }
    static async fetchClaims(app) {
        return utils_1.rslv((async function () {
            const token = await app.auth().currentUser.getIdTokenResult();
            //TODO create custom claims map and validate them
            return CustomClaimsMap_1.CustomClaimsMap.toDomain(token.claims, token.token, token.claims.user_id || token.claims.uid);
        })());
    }
    static async fetchOrgConfig(fbApp) {
        const res = await utils_1.rslv(fbApp.db.ref(`${fbApp.rootRefs.orgConfigs}/${fbApp.claims.orgId}`).once("value"));
        if (res.isFail)
            throw new Error(`${fbApp.rootRefs.orgConfigs} ${res.errMsg()}`);
        return OrgConfigMap_1.OrgConfigMap.toDomain(res.getValue().val(), fbApp.rootRefs.orgConfigs, fbApp.claims.orgId);
    }
    static async fetchPortalUiPermissions(fbApp) {
        const res = await utils_1.rslv(fbApp.db.ref(fbApp.ouRefs.portalUiPermissions).once("value"));
        if (res.isFail)
            throw new Error(`${fbApp.ouRefs.portalUiPermissions} ${res.errMsg()}`);
        return res.getValue().val();
    }
    static async fetchGlobalPortalUiPermissions(fbApp) {
        const res = await utils_1.rslv(fbApp.db.ref(fbApp.rootRefs.portalUiPermissions).once("value"));
        if (res.isFail)
            throw new Error(`${fbApp.rootRefs.portalUiPermissions} ${res.errMsg()}`);
        return res.getValue().val();
    }
    static async fetchAppUiPermissions(fbApp) {
        const res = await utils_1.rslv(fbApp.db.ref(fbApp.ouRefs.appUiPermissions).once("value"));
        if (res.isFail)
            throw new Error(`${fbApp.ouRefs.appUiPermissions} ${res.errMsg()}`);
        return res.getValue().val();
    }
    static ctxFromAuth(auth) {
        //TODO validate custom claims
        return { userId: auth.uid, orgId: auth.customClaims.orgId, accountId: auth.customClaims.accountId };
    }
    async clearPresence() {
        return this.db.ref(this.rootRefs.webPresence).child(this.userId).set(false);
    }
    async startHttpsCloudFunction(url, method = "GET", payload) {
        const tokenRes = await utils_1.rslv(this.auth.currentUser.getIdToken());
        if (tokenRes.isFail)
            throw new Error(`getIdToken ${tokenRes.errMsg()}`);
        return axios_1.default(url, {
            headers: { Authorization: `${EHttpAuth_1.EHttpAuth.V.BEARER} ${tokenRes.getValue()}` },
            method,
            data: payload,
        });
    }
}
exports.FirebaseApp = FirebaseApp;
//# sourceMappingURL=FirebaseApp.js.map